import { isSameCountry } from '@core/helpers';

const EARTH_RADIUS_KM = 6371;
export const MAX_STORE_DISTANCE_KM = 200;

function deg2rad(deg: number): number {
	return deg * (Math.PI / 180);
}

/**
 * Calculates distance between two coordinates in kilometers using Haversine formula.
 */
export function calculateDistanceInKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
	const dLat = deg2rad(lat2 - lat1);
	const dLon = deg2rad(lon2 - lon1);
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	return EARTH_RADIUS_KM * c;
}

/**
 * Validates if the given distance in km is within the maximum allowed threshold.
 */
export function isStoreWithinMaxDistance(distancia: number, maxKm: number = MAX_STORE_DISTANCE_KM): boolean {
	return distancia <= maxKm;
}

/**
 * Validates whether the store country matches the user country.
 */
export function isStoreInSameCountry(userCountry?: string | null, storeCountry?: string | null): boolean {
	if (!userCountry || !storeCountry) {
		return true;
	}
	return isSameCountry(userCountry, storeCountry);
}
